module.exports = __webpack_public_path__ + "img/icon-cog.048a679d.svg";